import { Instagram, Facebook, Linkedin, Mail, MapPin } from "lucide-react";
import { LOGO, NAV_LINKS, CONTACT } from "@/data/content";

const SOCIALS = [
  { icon: Instagram, label: "Instagram", href: "https://www.instagram.com/mirevaajourneys" },
  { icon: Facebook, label: "Facebook", href: "https://www.facebook.com/mirevaajourneys" },
  { icon: Linkedin, label: "LinkedIn", href: "https://www.linkedin.com/company/mirevaajourneys" },
];

export default function Footer({ onNavigate }) {
  return (
    <footer data-testid="site-footer" className="bg-forest text-ivory">
      <div className="mx-auto max-w-7xl px-6 py-16 md:px-10 md:py-20">
        <div className="grid grid-cols-1 gap-12 md:grid-cols-12">
          <div className="md:col-span-5">
            <div className="flex items-center gap-4">
              <img src={LOGO} alt="Mirevaa Journeys logo" className="h-16 w-16 rounded-full object-cover" />
              <div>
                <p className="font-display text-2xl tracking-[0.14em]">MIREVAA</p>
                <p className="mt-1 text-[9px] uppercase tracking-widest2 text-gold">Journeys</p>
              </div>
            </div>
            <p className="mt-6 max-w-sm text-sm leading-relaxed text-ivory/65">
              Curated Journeys. Personally Designed. Boutique, tailor-made international holidays for couples,
              families and celebrations — planned with care, from Kolkata to the world.
            </p>
            <div className="mt-7 flex items-center gap-4">
              {SOCIALS.map((s) => (
                <a
                  key={s.label}
                  data-testid={`footer-social-${s.label.toLowerCase()}`}
                  href={s.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label={`Mirevaa Journeys on ${s.label}`}
                  className="flex h-10 w-10 items-center justify-center border border-ivory/20 text-ivory/70 transition-colors duration-500 hover:border-gold hover:text-gold"
                >
                  <s.icon className="h-4 w-4" strokeWidth={1.5} />
                </a>
              ))}
            </div>
          </div>

          <div className="md:col-span-3">
            <p className="text-[10px] uppercase tracking-widest2 font-medium text-gold">Explore</p>
            <ul className="mt-6 space-y-3.5">
              {NAV_LINKS.map((l) => (
                <li key={l.id}>
                  <button
                    data-testid={`footer-link-${l.id}`}
                    onClick={() => onNavigate(l.id)}
                    className="text-sm text-ivory/70 transition-colors hover:text-gold"
                  >
                    {l.label}
                  </button>
                </li>
              ))}
              <li>
                <button
                  data-testid="footer-link-contact"
                  onClick={() => onNavigate("plan-your-journey")}
                  className="text-sm text-ivory/70 transition-colors hover:text-gold"
                >
                  Contact
                </button>
              </li>
            </ul>
          </div>

          <div className="md:col-span-4">
            <p className="text-[10px] uppercase tracking-widest2 font-medium text-gold">Contact</p>
            <div className="mt-6 space-y-4 text-sm text-ivory/70">
              <p className="font-display text-xl italic text-ivory">{CONTACT.founder}</p>
              <p className="text-xs uppercase tracking-widest2 text-ivory/50">{CONTACT.role}</p>
              <p className="flex items-center gap-3">
                <MapPin className="h-4 w-4 text-gold" strokeWidth={1.5} />
                {CONTACT.location}
              </p>
              <a
                data-testid="footer-email-link"
                href={`mailto:${CONTACT.email}`}
                className="flex items-center gap-3 transition-colors hover:text-gold"
              >
                <Mail className="h-4 w-4 text-gold" strokeWidth={1.5} />
                {CONTACT.email}
              </a>
              <a
                data-testid="footer-website-link"
                href={CONTACT.siteUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="inline-block transition-colors hover:text-gold"
              >
                {CONTACT.site}
              </a>
            </div>
          </div>
        </div>

        <div className="mt-16 flex flex-col items-center justify-between gap-4 border-t border-ivory/10 pt-8 md:flex-row">
          <p className="text-[11px] tracking-wide text-ivory/45">
            © {new Date().getFullYear()} Mirevaa Journeys · Curated Journeys. Personally Designed.
          </p>
          <p className="text-[11px] tracking-wide text-ivory/45">
            Premium International Holidays · Tailor-Made Travel · Kolkata, India
          </p>
        </div>
      </div>
    </footer>
  );
}
